import DOMPurify from 'dompurify';
import React from 'react';

interface HTextProps {
    className?: string;
    asSpan?: boolean;
    children: string | null;
}

const HText = (props: HTextProps) => {
    const sanitize = (text: string) => {
        return DOMPurify.sanitize(text);
    };

    return props.asSpan ? (
        <span
            className={props.className}
            data-html="true"
            dangerouslySetInnerHTML={{ __html: sanitize(props.children || '') }}
        />
    ) : (
        <div
            className={props.className}
            data-html="true"
            dangerouslySetInnerHTML={{ __html: sanitize(props.children || '') }}
        />
    );
};

export default HText;
